import React from "react";
import "./CommandPanelButton.css";

type Props = {
  icon: React.ReactNode;
  disabled?: boolean;
  id: string;
  onClick: (id: string) => any;
  content: string;
  showArrow?: boolean;
};

export default function CommandButton({ icon, disabled = false, id, onClick, content, showArrow = false }: Props) {
  const buttonOnClick = !disabled ? onClick : () => {};
  return (
    <button className={"command-button"} key={id} id={id} onClick={() => buttonOnClick(id)} disabled={disabled}>
      <div className={"command-button-icon"} style={{}}>
        {icon}
      </div>

      <div className={"command-button-separator"} />
      <div className={"command-button-label"}>
        <span>{content}</span>
      </div>

      {showArrow && (
        <div className={"command-button-arrow"}>
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none">
            <path d="M5.99999 6.41209L0 0H12L5.99999 6.41209Z" fill="#414042" />
          </svg>
        </div>
      )}
    </button>
  );
}
